// tableIDs
export const USE_CASE_TABLE_ID = 'useCaseInventory';
export const MODEL_TABLE_ID = 'modelInventory';
export const RISK_TABLE_ID = 'riskInventory';
export const ASSESSMENT_LOG_TABLE_ID = 'assessmentLog';
export const GOVERNANCE_EVALUATION_LOG_TABLE_ID = 'customAssessmentLog';
export const AI_ASSESSMENT_TABLE_ID = 'aiAssessmentInventory';
export const RISK_PROFILE_TABLE_ID = 'riskProfileTable';
export const DATASET_TABLE_ID = 'dataInventory';

// Initial states for column visibility
const USE_CASE_COLUMN_VISIBILITY = {
  purpose: false,
  aiModels: true,
  department: false,
  description: false,
  materiality: true,
  readiness: true,
  businessOwner: false,
  euAiActRiskClass: true,
  hasQuestionnaire: true,
  url: false,
};

const MODEL_COLUMN_VISIBILITY = {
  status: true,
  useCase: true,
  liveFrom: false,
  taskType: true,
  datasetInfo: false,
  technicalInfo: false,
  technicalOwner: false,
  decomissionedOn: false,
  latestAssessmentStatus: true,
};

const ASSESSMENT_COLUMN_VISIBILITY = {
  status: true,
  endTime: false,
  startTime: true,
  timestamp: false,
  elapsedTime: true,
  estimatedTime: false,
  aiModelTaskType: false,
};

const GOVERNANCE_EVALUATION_COLUMN_VISIBILITY = {
  id: true,
  useCase: true,
  questionnaire: true,
  updatedAt: true,
  updatedBy: true,
};

const AI_ASSESSMENT_COLUMN_VISIBILITY = {
  step: true,
};

const DATASET_COLUMN_VISIBILITY = {
  taskType: true,
  taskName: true,
  progress: true,
  startTime: false,
  endTime: false,
  errorMessage: false,
  status: true,
  perturbations: true,
  predictions: true,
};

export const COLUMN_VISIBILITY = {
  [USE_CASE_TABLE_ID]: USE_CASE_COLUMN_VISIBILITY,
  [MODEL_TABLE_ID]: MODEL_COLUMN_VISIBILITY,
  [ASSESSMENT_LOG_TABLE_ID]: ASSESSMENT_COLUMN_VISIBILITY,
  [AI_ASSESSMENT_TABLE_ID]: AI_ASSESSMENT_COLUMN_VISIBILITY,
  [GOVERNANCE_EVALUATION_LOG_TABLE_ID]: GOVERNANCE_EVALUATION_COLUMN_VISIBILITY,
  [DATASET_TABLE_ID]: DATASET_COLUMN_VISIBILITY,
};
